export default __webpack_public_path__ + "static/media/reference-digital-via-publica.e0d7d759.svg";